import { action, computed, observable } from 'mobx';
import moment from 'moment';
import { Designable } from '../../Entity';
import CabinetPage from '../page/cabinet-page';

export enum CabinetComponentType {
    Header = 'header',
    Footer = 'footer'
}

export default class CabinetComponent extends Designable {
    constructor(item?: Partial<CabinetComponent>) {
        super(item);
        if (item) this.update(item);
    }

    @observable name: string;
    @observable type: CabinetComponentType;
    @observable isFixed: boolean = false;
    @observable isProtected: boolean = false;
    @observable cabinetId: string;
    @observable createdDate: moment.Moment;
    @observable updatedDate: moment.Moment | null;
    @observable headerPages: CabinetPage[];
    @observable footerPages: CabinetPage[];

    static fromJson(json: any): CabinetComponent {
        return new CabinetComponent({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
            headerPages: json.headerPages ? json.headerPages.map(CabinetPage.fromJson) : [],
            footerPages: json.footerPages ? json.footerPages.map(CabinetPage.fromJson) : [],
        });
    }

    @action
    update(changes: Partial<CabinetComponent>) {
        super.update(changes);
    }

    @computed get pages() {
        switch (this.type) {
            case CabinetComponentType.Header:
                return this.headerPages ?? [];
            case CabinetComponentType.Footer:
                return this.footerPages ?? [];
            default:
                return [];
        }
    }

    @computed get pageIds() {
        return this.pages.map(i => i.id);
    }

    @action
    updatePages(pages: CabinetPage[]) {
        switch (this.type) {
            case CabinetComponentType.Header:
                this.headerPages = [...pages];
                break;
            case CabinetComponentType.Footer:
                this.footerPages = [...pages];
                break;
        }
    }
}
